import React, { Fragment } from 'react'

import PropTypes from 'prop-types'

import './feature.css'

const Feature = (props) => {
  return (
    <div className={`feature-feature ${props.rootClassName} `}>
      <img
        alt={props.thumbnailAlt}
        src={props.thumbnail}
        className="feature-image"
      />
      <div className="feature-content">
        <span className="feature-title1">
          {props.title1 ?? (
            <Fragment>
              <span className="feature-text1"></span>
            </Fragment>
          )}
        </span>
        <span className="feature-description">{props.description}</span>
      </div>
      <span className="feature-title2">
        {props.title11 ?? (
          <Fragment>
            <span className="feature-text2"></span>
          </Fragment>
        )}
      </span>
    </div>
  )
}

Feature.defaultProps = {
  title1: undefined,
  thumbnailAlt: 'image',
  thumbnail: '/vector.svg',
  rootClassName: '',
  description:
    'Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusa',
  title11: undefined,
}

Feature.propTypes = {
  title1: PropTypes.element,
  thumbnailAlt: PropTypes.string,
  thumbnail: PropTypes.string,
  rootClassName: PropTypes.string,
  description: PropTypes.string,
  title11: PropTypes.element,
}

export default Feature
